var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { PaginationContainer } from './styles';
import { PaginationBase } from './PaginationBase';
import DropDown from '../DropDown';
import { Spacer } from '../base';
var Pagination = function (_a) {
    var pageCount = _a.pageCount, selectedPage = _a.selectedPage, selectionValueList = _a.selectionValueList, selectionValueSuffix = _a.selectionValueSuffix, defaultSelectionListValue = _a.defaultSelectionListValue, onPageChange = _a.onPageChange, onListValueChange = _a.onListValueChange, hideSelectionList = _a.hideSelectionList, hideBorders = _a.hideBorders;
    return (_jsxs(PaginationContainer, __assign({ noBorders: hideBorders }, { children: [_jsx(PaginationBase, { onPageChange: onPageChange, pageCount: pageCount, selectedPage: selectedPage }), !hideSelectionList &&
                selectionValueList &&
                onListValueChange &&
                defaultSelectionListValue && (_jsxs(_Fragment, { children: [_jsx(Spacer, {}), _jsx(DropDown, { list: selectionValueList, onChange: onListValueChange, defaultValue: defaultSelectionListValue, listSuffix: selectionValueSuffix, size: "medium" })] }))] })));
};
export default Pagination;
